import * as React from "react";
const SvgShieldExclamation = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13.9736 2.93245C13.6675 2.95801 13.3536 2.97181 13.0335 2.97181C10.901 2.97181 9.0333 2.38258 8.00001 1.5C6.96672 2.38241 5.09905 2.97181 2.96667 2.97181C2.64644 2.97181 2.3327 2.95801 2.02644 2.93245C1.94867 4.69794 1.98223 7.71069 2.98561 9.88694C4.37535 12.9014 7.99835 14.4992 8.00001 14.5C8.00167 14.4992 11.6245 12.9014 13.0144 9.88694C14.0176 7.71069 14.0513 4.69794 13.9736 2.93245ZM12.0679 9.44002C11.1251 11.4851 8.91814 12.8316 8.00001 13.3217C7.07623 12.8289 4.87455 11.4844 3.93199 9.44002C3.50508 8.51404 3.03031 6.84762 3.04361 4.02865C4.95448 4.01687 6.73773 3.56557 8.00001 2.79334C9.26212 3.56557 11.0455 4.01687 12.9564 4.02865C12.9697 6.84728 12.4949 8.51387 12.0679 9.44002Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.88069 4.48835C7.78149 4.38793 7.62943 4.37885 7.54136 4.46816L4.45246 7.59445C4.36438 7.68377 4.37303 7.83768 4.47257 7.93809C4.57177 8.03851 4.72366 8.04743 4.8119 7.95828L7.90063 4.83199C7.98904 4.74268 7.9799 4.58877 7.88069 4.48835Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.71552 6.05386L6.01901 7.77074C5.93094 7.86006 5.93958 8.0138 6.03912 8.11422C6.13816 8.21481 6.29022 8.22356 6.37846 8.13441L8.07479 6.41769C8.1632 6.32821 8.15422 6.1743 8.05502 6.07405C7.95548 5.97363 7.80359 5.96454 7.71552 6.05386Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10C11.3431 10 10 11.3431 10 13C10 14.6569 11.3431 16 13 16Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M12.5927 11.5595C12.577 11.3243 12.7643 11.125 13.0009 11.125C13.2391 11.125 13.4269 11.3268 13.4088 11.5633L13.2591 13.519C13.2492 13.6493 13.1401 13.75 13.0088 13.75H12.9742C12.8421 13.75 12.7325 13.648 12.7237 13.5166L12.5927 11.5595Z",
	fill: "#FAC031"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M12.9904 14.875C13.1984 14.875 13.367 14.7071 13.367 14.5C13.367 14.2929 13.1984 14.125 12.9904 14.125C12.7824 14.125 12.6138 14.2929 12.6138 14.5C12.6138 14.7071 12.7824 14.875 12.9904 14.875Z",
	fill: "#FAC031"
}));
export default SvgShieldExclamation;
